/* eslint-disable internal-rules/no-invalid-shared-folder-exports */
import type {
	CommentRole,
	RecentPromotionsRefundedStatus,
	RecentPromotionsSource,
} from '@change-corgi/middle-end-gql-schema';

export const PETITION_ACTIVITY_PROMOTION_SOURCES: readonly RecentPromotionsSource[] = [
	'PROMOTION',
	'FREE_PROMOTION',
	'STARTER_FREE_PROMOTION',
] as const;
export const PETITION_ACTIVITY_PROMOTION_REFUNDED_STATUS: RecentPromotionsRefundedStatus = 'NON_REFUNDED';
export const PETITION_ACTIVITY_COMMENT_ROLES: readonly CommentRole[] = [
	'COMMENT',
	'SUPPORTER_COMMENT',
	'VIDEO_COMMENT',
] as const;
